import React from 'react';
import { DateLayout } from './styles.Date';
import 'moment/locale/de';
import moment from 'moment';

interface DateProps {
    day: number;
    month: number;
    year: number;
    time?: string;
}

export const Date: React.FC<DateProps> = ({ day, month, year, time }) => {
    const date = moment(`${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}T${time}:00`);
    const withFromNow = moment().diff(moment(date)) <= 6.048e8;
    return (
        <DateLayout fromNow={withFromNow} format={withFromNow ? undefined : 'DD.MM.YYYY HH:MM'} locale="de">
            {date}
        </DateLayout>
    );
};
